var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_fill 1",
    clipPath: "url(#clip0_129_2850)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M2.41251 6.39503L12.7676 16.7501C13.4083 17.3908 14.4223 17.4309 15.1095 16.8702L15.2424 16.7501L25.5898 6.40273C25.6234 6.52969 25.6464 6.66088 25.658 6.79534L25.6668 6.99935V20.9993C25.6668 22.2295 24.715 23.2372 23.5076 23.3263L23.3335 23.3327H4.66683C3.43674 23.3327 2.42897 22.3809 2.3399 21.1735L2.3335 20.9993V6.99935C2.3335 6.86002 2.34571 6.72354 2.36912 6.59092L2.41251 6.39503ZM23.3335 4.66602C23.4747 4.66602 23.613 4.67856 23.7473 4.70259L23.9456 4.74713L14.0051 14.6877L4.06239 4.74507C4.19091 4.71069 4.3238 4.68702 4.46006 4.67505L4.66683 4.66602H23.3335Z",
    fill: "#233334"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlack);
export default __webpack_public_path__ + "static/media/mailBlack.adf0413c10d4869ff9b89ec6f58ac9a2.svg";
export { ForwardRef as ReactComponent };